import React from 'react';
import {connect} from "react-redux";
import * as actions from "../../store/actions";
import SelectOptionsForm from "../../components/SelectOptionsForm";

const Step4 = (props) => {
    return (
        <React.Fragment>

            <SelectOptionsForm vehicle={props.vehicle} trims={props.trims} exteriorColors={props.exteriorColors}
                               interiorColors={props.interiorColors} app={props.app} onNext={props.onNext}
                               onBack={props.onBack} onBlackBookColorRequest={props.onBlackBookColorRequest}
                               onClose={props.handleClose}
                               nextButton="Save"
                               backButton="Back"
            ></SelectOptionsForm>

        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        app: state.app.qualifyVehicle,
        vehicle: state.qualifyVehicle.vehicle,
        trims: state.qualifyVehicle.trims,
        exteriorColors: state.qualifyVehicle.exteriorColors,
        interiorColors: state.qualifyVehicle.interiorColors
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onNext: (data, nextStep) => dispatch(actions.saveQuestions(data)),
        onBack: () => dispatch(actions.backQualifyVehicle()),
        onBlackBookColorRequest: (uvc) => dispatch(actions.getBlackBookColor(uvc))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step4);